import React from 'react';
import { arrayOf, shape, string } from 'prop-types';

import styles from '../../styles.module.scss';
import ClientRow from '../ClientRow';
import CheckoutAnswers from '../CheckoutAnswers';
import { checkoutAnswerTypes } from '../CheckoutAnswers/types';

function ClientDetails({ clients, checkoutAnswers }) {
  return (
    <div className={`m-left-2 m-right-2 ${styles.border}`}>
      <div className="column space-around">
        {clients.map(
          ({ text, value, hide }) =>
            value && !hide && <ClientRow key={text} text={text} value={value} style={styles.clientTitle} />
        )}
      </div>
      <CheckoutAnswers checkoutAnswers={checkoutAnswers} />
    </div>
  );
}

ClientDetails.propTypes = {
  ...checkoutAnswerTypes,
  clients: arrayOf(
    shape({
      clientName: string,
      phone: string,
      address: string,
      apartmentDetails: string,
      deliveryNotes: string
    })
  )
};

export default ClientDetails;
